/** @format */

import { debounce } from 'lodash';
import { useCallback, useState } from 'react';
import { useServerError } from './use-server-error';

const defaultState = {
  title: '',
  message: '',
  labelButton: '',
  open: false,
  params: {},
  callbackSuccess: () => {},
  callbackError: () => {},
  handleAgree: () => Promise.resolve()
};

export const useActionConfimSubmit = () => {
  const { processError } = useServerError();
  const [confirmActive, setConfirmActive] = useState(defaultState);

  const handleOpenDialogConfirm = ({ title, message, labelButton = 'Xoá', params, handleAgree }) => {
    setConfirmActive({
      open: true,
      title: title,
      message: message,
      labelButton: labelButton,
      params: params,
      handleAgree: handleAgree
    });
  };

  const handleCloseDialogConfirm = () => {
    setConfirmActive(defaultState);
  };

  const handleAgreeDialogConfirm = useCallback(
    debounce(async (params) => {
      try {
        await confirmActive.handleAgree(params, confirmActive.callbackSuccess, confirmActive.callbackError);
      } catch (error) {
        processError(error);
      } finally {
        handleCloseDialogConfirm();
      }
    }, 200),
    [confirmActive.handleAgree]
  );

  return {
    handleOpenDialogConfirm,
    handleCloseDialogConfirm,
    handleAgreeDialogConfirm,
    state: confirmActive
  };
};
